<!--呼吸频率-->
<template>
  <article class="cur_con_wrapper" ref="alerts">
    <div class="cur_con">
      <header class="header">
        <i class="iconfont">&#xe6ce;</i>
        <h2>{{$t('currentBox.huxi')}}</h2>
      </header>
      <p class="time">({{ startTime }} -- {{ endTime }})</p>
      <div class="charts">
        <div class="data">
          <keep-alive>
            <div class="chart" :id="id"></div>
          </keep-alive>
        </div>
        <p class="tip_txt">*{{$t('tag.shipin')}}</p>
        <ul class="item_list">
          <li>
            <div
              :class="['value', lastBreath.value !== '' && lastBreath.color !== 'normal' ? lastBreath.color : '' ]"
            >
              <template v-if="lastBreath.value !== ''">
                <strong>{{lastBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <p class="title">{{$t('tag.breathe.dangqian')}}</p>
          </li>
          <li>
            <div
              :class="['value', aveBreath.value !== '' && aveBreath.color !== 'normal' ? aveBreath.color : '' ]"
            >
              <template v-if="aveBreath.value !== ''">
                <strong>{{aveBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <div class="title">{{$t('tag.breathe.pingjun')}}</div>
          </li>
    
        </ul>
        <ul class="item_list">
          <li>
            <div
              :class="['value', lowBreath.value !== '' && lowBreath.color !== 'normal' ? lowBreath.color : '' ]"
            >
              <template v-if="lowBreath.value !== ''">
                <strong>{{lowBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <p class="title">{{$t('tag.breathe.jinrizuidi')}}</p>
          </li>
                <li>
            <div
              :class="['value', topBreath.value !== '' && topBreath.color !== 'normal' ? topBreath.color : '' ]"
            >
              <template v-if="topBreath.value !== ''">
                <strong>{{topBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <p class="title">{{$t('tag.breathe.jinrizuigao')}}</p>
          </li>
     <!--      <li>
            <div
              :class="['value', topBreathPre.value !== '' && topBreathPre.color !== 'normal' ? topBreathPre.color : '' ]"
            >
              <template v-if="topBreathPre.value !== ''">
                <strong>{{topBreathPre.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <p class="title">{{$t('tag.breathe.zuorizuigao')}}</p>
          </li> -->
   <!--        <li>
            <div
              :class="['value', lowBreathPre.value !== '' && lowBreathPre.color !== 'normal' ? lowBreathPre.color : '' ]"
            >
              <template v-if="lowBreathPre.value !== ''">
                <strong>{{lowBreathPre.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>
                <strong>--</strong>
              </template>
            </div>
            <p class="title">{{$t('tag.breathe.zuorizuidi')}}</p>
          </li> -->
        </ul>
      </div>
      <div class="read">
        <header>
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('tag.canshujiedu')}}</h2>
        </header>
        <div class="content">
          <div :class="['article',contentShow ? 'show' : 'hidden']">{{$t('breathe.current')}}</div>
          <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
            <i class="iconfont" v-show="!contentShow">&#xe632;</i>
            <i class="iconfont" v-show="contentShow">&#xe633;</i>
          </div>
        </div>
      </div>
      <div class="silder">
        <i class="iconfont" @click="goBack">&#xe669;</i>
        <i class="iconfont" @click="scrollTop">&#xe634;</i>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "CurrentBreathe",
  props: {
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      id: "CurrentBreathe",
      breatheTime: [],
      breatheValue: [],

      lastBreath: {},
      aveBreath: {},
      topBreath: {},
      lowBreath: {},
      topBreathPre: {},
      lowBreathPre: {},
      startTime: "00:00",
      endTime: "23:59",
      contentShow: false,
      tipShow: false,
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    this.getCurrentDataInfo();
    var echartsDom = document.getElementById(this.id);
    var contentHeight = window.getComputedStyle(echartsDom).height;
    var contentWidth = window.getComputedStyle(echartsDom).width;
    echartsDom.style.height = contentHeight;
    echartsDom.style.width = contentWidth;
  },
  computed: {
    options() {
      return {
        series: {
          type: "bar",
          barWidth: '40%',
          data: this.breatheValue,
            itemStyle: {
            normal: {
              color: function (params) {
                 if (params.data !== null && params.data !== undefined) {
                  if (params.data >= 12 && params.data <24) {
                     return '#007ee9'  //蓝色
                  }  else if (params.data >= 24 && params.data < 28) {
                     return '#f39800' // 橙色
                  } else {
                    return '#ea3535'  //红色
                  }
                }
                //console.log(params);

              }
            }
          }

        },
        color: "#3596ea",
        grid: {
          containLabel: true,
          top: 20,
          bottom: 10,
          left: 0,
          right: 0
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let val = Number(params[0].value);
            let time = params[0].axisValue;
            let res = ` ${time}<br/> ${val} 次/分`;
            return res;
          }
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#54657e",
              width: 1
            }
          },
          data: this.breatheTime
        },
        yAxis: {
          type: "value",
          min: 0,
          interval: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cad3df",
              width: 1
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }
      };
    }
  },
  methods: {
    getCurrentDataInfo() {
      //console.log("呼吸时间===" + this.current);
      let postData = {
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token,
        current: this.current
      };
      this.$axios
        .getCurrentBreathe(this.appType, postData)
        .then(this.getCurrentDataInfoSucc);
    },
    getCurrentDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        const data = res.data;
        this.breatheTime = [];
        this.breatheValue = [];

        for (let item of data.echarts) {
          this.breatheTime.push(item.time);
          this.breatheValue.push(item.breath);
        }
        this.lastBreath = data.outlineData.lastBreath;
        this.aveBreath = data.outlineData.aveBreath;
        this.topBreath = data.outlineData.topBreath;
        this.lowBreath = data.outlineData.lowBreath;
        this.topBreathPre = data.outlineData.topBreathPre;
        this.lowBreathPre = data.outlineData.lowBreathPre;
        this.startTime = data.outlineData.startTime;
        this.endTime = data.outlineData.endTime;
        this.init();
        this.setOption(this.options);
      }
    },

    init() {
      let _this = this;
      this.chart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function() {
        _this.chart = _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option);
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    goBack() {
      this.$router.go(-1);
    },
    scrollTop() {
      window.scrollTo(0, 0);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/CurrentData.styl';

.modal-list {
  li {
    color: #333;
    padding: 0.1rem 0.2rem 0.1rem 0;
    margin: 0;
    display: flex;

    &:nth-of-type(odd) {
      background: #efefef;
    }

    &:nth-of-type(even) {
      background: #fff;
    }

    span {
      display: block;
      flex: 1;
      text-align: center;
      font-size: 0.24rem;

      &.time {
        flex: 2;
      }
    }
  }

  .red {
    color: $redText;
  }

  .normal {
    color: #333;
  }
}

.cur_con_wrapper {
  .cur_con {
    .time {
      font-size: 0.26rem;
      text-indent: 0.8rem;
      margin-top: -0.1rem;
    }

    .header {
      display: flex;
      margin-bottom: 0.2rem;

      .warning {
        display: flex;
        box-sizing: border-box;
        justify-content: space-around;
        border: solid $grayText;
        border-radius: 0.1rem;
        position: absolute;
        display: block;
        padding: 0.05rem 0.1rem;
        top: 0.4rem;
        right: 0.1rem;
        color: $grayText;

        .text {
          vertical-align: middle;
          font-size: 0.24rem;
        }

        .iconfont {
          font-size: 0.3rem;
          margin: 0;
          color: $grayText;
        }

        .num {
          font-size: 0.24rem;
          line-height: 0.3rem;
          display: inline-block;
          border-radius: 0.03rem;
          padding: 0 0.08rem;
          height: 0.3rem;
          color: #ffffff;
          text-align: center;
          background: $grayText;
        }

        &.red {
          color: $redText;
          border: solid $redText;

          .num {
            background: $redText;
          }

          .iconfont {
            color: $redText;
          }
        }

        &.orange {
          color: $orangeText;
          border: solid $orangeText;

          .num {
            background: $orangeText;
          }

          .iconfont {
            color: $orangeText;
          }
        }
      }
    }

    .charts {
      .item_list {
        width: 100%;

        li {
          width: 33.33%;
          // margin 0.3rem 0.2rem
        }
      }
    }

    .assessment {
      .assessment_list {
        .level {
          &.normal {
            color: #333;
          }

          strong {
            font-size: 0.6rem;
            margin-bottom: 0.08rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/current-data/components/CurrentBreathe.vue